import { deprecated } from "lib/helpers";
import { createInlineStylePlugin } from "./inlineStylePlugin/createInlineStylePlugin";
import { createBlockStylePlugin } from "./blockStylePlugin/createBlockStylePlugin";
import { createLinkPlugin } from "./linkPlugin/createLinkPlugin";
import { createCodeEditPlugin } from './codeEditPlugin/createCodeEditPlugin';
import { createImagePlugin } from "./imagePlugin/createImagePlugin";
import { createDebugPlugin } from "./debugPlugin/createDebugPlugin";
import { createTablePlugin } from "./tablePlugin/createTablePlugin";
import { createPasteHtmlPlugin } from "./pasteHtmlPlugin/createPasteHtmlPlugin";
import { createFocusPlugin } from "./focusPlugin/createFocusPlugin";
import { createStickToolbarPlugin } from "./stickToolbarPlugin/createStickToolbarPlugin";
import { createFileImportPlugin } from "./fileImportPlugin/createFileImportPlugin";
import { createTitlePlugin } from "./titlePlugin/createTitlePlugin";
import { createVideoPlugin } from "./videoPlugin/createVideoPlugin";
import { createFormulaPlugin } from "./formulaPlugin/createFormulaPlugin";
import { createHrPlugin } from "./hrPlugin/createHrPlugin";
import { createPlaceholderPlugin } from "./placeholderPlugin/createPlaceholderPlugin";
import { createMetaPlugin } from "./metaPlugin/createMetaPlugin";


export function createAllPlugins(options = {}) {
	if (options.docImport) {
		deprecated('docImport 插件已更名为 fileImport 插件，请改用 fileImport 配置项');
		options.fileImport = options.docImport;
	}

	const focusPlugin = createFocusPlugin(options.focus);
	const titlePlugin = createTitlePlugin(options.title);
	const disabled = name => options[name] && options[name].disabled === true;

	return [
		!disabled('inlineStyle') && createInlineStylePlugin(options.inlineStyle),
		!disabled('blockStyle') && createBlockStylePlugin(options.blockStyle),
		!disabled('hr') && focusPlugin.decoratePlugin(createHrPlugin(options.hr)),
		!disabled('link') && createLinkPlugin(options.link),
		!disabled('codeEdit') && createCodeEditPlugin(options.codeEdit),
		!disabled('formula') && createFormulaPlugin(options.formula),
		!disabled('focus') && focusPlugin,
		!disabled('image') && focusPlugin.decoratePlugin(titlePlugin.decoratePlugin(createImagePlugin(options.image))),
		!disabled('video') && focusPlugin.decoratePlugin(titlePlugin.decoratePlugin(createVideoPlugin(options.video))),
		!disabled('table') && createTablePlugin(options.table),
		!disabled('debug') && createDebugPlugin(options.debug),
		!disabled('pasteHtml') && createPasteHtmlPlugin(options.pasteHtml),
		!disabled('stickToolbar') && createStickToolbarPlugin(options.stickToolbar),
		!disabled('fileImport') && focusPlugin.decoratePlugin(titlePlugin.decoratePlugin(createFileImportPlugin(options.fileImport))),
		!disabled('placeholder') && createPlaceholderPlugin(options.placeholder),
		!disabled('meta') && focusPlugin.decoratePlugin(createMetaPlugin(options.meta)),
	];
};



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/createAllPlugins.js